(() => {
  let dispose;
  function init() {
    dispose?.();
    const button = document.querySelector('[data-plp-back-to-top]');
    const heading = document.getElementById(button?.getAttribute('aria-controls'));
    if (!button || !heading) return;
    let frame;
    const update = () => {
      frame = undefined;
      const grid = document.querySelector('.ais-results-size-lg .ais-hits-container, .ais-results-size-md .ais-hits-container');
      const bounds = grid?.getBoundingClientRect();
      button.style.left = bounds?.width > 0 ? `${bounds.left + bounds.width / 2}px` : '';
      button.hidden = window.scrollY <= window.innerHeight || heading.getBoundingClientRect().bottom >= 0;
    };
    const schedule = () => {
      if (frame === undefined) frame = window.requestAnimationFrame(update);
    };
    const results = document.getElementById('algolia-shopify-instantsearch');
    const responsiveObserver = new MutationObserver(schedule);
    if (results) responsiveObserver.observe(results, { attributes: true, attributeFilter: ['class'] });
    const returnToHeading = () => {
      const header = document.getElementById('shopify-section-header');
      const stickyHeader = header?.querySelector('sticky-header');
      const streamerHeight = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--ts-h')) || 0;
      const offset = streamerHeight + (stickyHeader ? header.offsetHeight : 0) + 12;
      const top = Math.max(0, window.scrollY + heading.getBoundingClientRect().top - offset);
      stickyHeader?.reveal?.();
      heading.focus({ preventScroll: true });
      window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    button.addEventListener('click', returnToHeading);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('pageshow', schedule);
    update();
    dispose = () => {
      window.cancelAnimationFrame(frame);
      responsiveObserver.disconnect();
      button.hidden = true;
      button.removeEventListener('click', returnToHeading);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('pageshow', schedule);
      dispose = undefined;
    };
  }
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('[data-plp-back-to-top]')) dispose?.();
  });
})();
